import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class globalEmitterService {
  public updateCart = new BehaviorSubject<boolean>(false);
  public placeOrder = new BehaviorSubject<boolean>(false);
  public loaderUpdate = new BehaviorSubject<boolean>(false);
  public gotoNextPage = new BehaviorSubject<any>(null);
  constructor() {}
}
